﻿import React, { useEffect, useRef, useState } from "react";
import { SAVE_COMPANIES_TRADES, SAVE_TRADE_PRODUCTS, SEARCH_TRADES } from "../../constant/Apipath";
import {
  Box,
  Card,
  Checkbox,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { Postrequestcall } from "../../request/Postrequest";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import SearchField from "./SearchField";
import { English } from "../../constant/EnglishFallback";

const AddTradeModal = ({
  open,
  onClose,
  alreadyTradesSelected,
  mainId,
  onTradesSaveSuccessfully,
  from
}) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;

  const debounceTimeout = useRef(null);

  const [tradeList, setTradeList] = useState([]);
  const [selectedTrades, setSelectedTrades] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);

  const {
    TEXT_SELECT_TRADE = English?.AddTradeModal?.TEXT_SELECT_TRADE,
    TEXT_SEARCH_FOR_TRADE = English?.AddTradeModal?.TEXT_SEARCH_FOR_TRADE,
    TEXT_NO_RESULTS_FOUND = English?.AddTradeModal?.TEXT_NO_RESULTS_FOUND
  } = multiLanguageData?.AddTradeModal || {};

  useEffect(() => {
    getData(searchTerm);
  }, []);

  const getData = async (searchTerm) => {
    try {
      setIsLoading(true);
      let obj = {
        UserId: Number(currentUserId),
        SearchString: searchTerm,
        MyTradeCategory: "",
        PageNumber: 1,
        NrRowsPerPage: 100
      };

      const res = await Postrequestcall(SEARCH_TRADES, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      setTradeList(resData);
    } catch (error) {
      console.log("getData-> Error When Getting Trades Data: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCheckboxChange = (item) => {
    if (selectedTrades.some((t) => t?.id === item?.id)) {
      setSelectedTrades(selectedTrades.filter((t) => t.id !== item.id));
    } else {
      setSelectedTrades([...selectedTrades, item]);
    }
  };

  const getObject = () => {
    if (from === "product") {
      const SaveList = selectedTrades.map((item) => {
        return {
          Id: 0,
          ProductId: mainId ?? 0,
          TradeId: item.id,
          ModifiedBy: Number(currentUserId)
        };
      });
      const saveObject = {
        userId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList
      };
      return saveObject;
    } else {
      const SaveList = selectedTrades.map((item) => {
        return {
          Id: 0,
          CompanyId: mainId ?? 0,
          TradeId: item.id,
          ModifiedBy: Number(currentUserId)
        };
      });
      const saveObject = {
        userId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList
      };
      return saveObject;
    }
  };

  const getTradeSaveUrl = () => {
    if (from === "product") {
      return SAVE_TRADE_PRODUCTS;
    } else {
      return SAVE_COMPANIES_TRADES;
    }
  };

  const onSaveTrades = async () => {
    try {
      if (selectedTrades.length == 0) {
        return handleClose();
      }
      setSubmitLoading(true);

      let saveObject = getObject();
      let url = getTradeSaveUrl();
      await Postrequestcall(url, saveObject, loginData?.accessToken);
      onTradesSaveSuccessfully();
      handleClose();
    } catch (err) {
      console.log("onSaveTrades-> Error When Saving Trades: ", err);
    } finally {
      handleClose();
    }
  };

  const handleClose = () => {
    setSelectedTrades([]);
    setSubmitLoading(false);
    onClose();
  };

  return (
    <Modal open={open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6" sx={{ ml: 1 }}>
            {TEXT_SELECT_TRADE}
          </Typography>
          <Stack direction={"row"}>
            <IconButton onClick={() => onClose()}>
              <CloseIcon />
            </IconButton>
            <IconButton
              color="primary"
              loading={submitLoading}
              variant="contained"
              onClick={onSaveTrades}
              disabled={selectedTrades.length == 0}>
              <SaveIcon />
            </IconButton>
          </Stack>
        </Box>
        <SearchField
          value={searchTerm}
          onChange={(value) => {
            setIsLoading(true);
            const searchValue = value;
            setSearchTerm(searchValue);
            if (debounceTimeout.current) {
              clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
              getData(value);
            }, 1000);
          }}
          onSubmit={() => {
            setSearchTerm(searchTerm);
            getData(searchTerm);
          }}
          placeholder={TEXT_SEARCH_FOR_TRADE}
        />

        {isLoading ? (
          <Box sx={{ height: "450px" }}>
            <Loader />
          </Box>
        ) : (
          <Box>
            <Box
              sx={{
                marginTop: "10px",
                height: "440px",
                overflow: "auto",
                scrollbarWidth: "none"
              }}>
              <List disablePadding>
                {tradeList.length != 0 ? (
                  <Stack sx={{ gap: 1 }} >
                    {tradeList.map((item, index) => {
                      return (
                        <Card key={index.toString()} className="pagelist-content">
                          <ListItem key={index.toString()} disablePadding>
                            <ListItemButton
                              onClick={() => handleCheckboxChange(item)}
                              disabled={alreadyTradesSelected?.some(
                                (selectedItem) => selectedItem?.tradeId === item?.id
                              )}
                              sx={{ display: "flex", flexDirection: "row" }}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={
                                      alreadyTradesSelected?.some(
                                        (selectedItem) => selectedItem?.tradeId === item?.id
                                      ) || selectedTrades.some((t) => t?.id === item?.id)
                                    }
                                    onChange={() => handleCheckboxChange(item)}
                                    disabled={alreadyTradesSelected?.some(
                                      (selectedItem) => selectedItem?.tradeId === item?.id
                                    )}
                                  />
                                }
                              />
                              <ListItemText>{item?.name?.trim()}</ListItemText>
                            </ListItemButton>
                          </ListItem>
                        </Card>
                      );
                    })}
                  </Stack>
                ) : (
                  <Typography variant="body1" sx={{ color: "text.secondary" }}>
                    {TEXT_NO_RESULTS_FOUND}
                  </Typography>
                )}
              </List>
            </Box>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default AddTradeModal;

